export default __webpack_public_path__ + "static/media/DNo.27-2.1d35b330.jpg";